import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import ContactForm from "./components/ContactForm";
import FAQ from "./components/FAQ";

import styles from "./styles.module.scss";

const Contact: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Contact us page</title>
        <meta name="about" content="Humming home's contact page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ContactForm />
      <FAQ />
      <StartHumming fillColor="white" />
    </div>
  );
};

Contact.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Contact;
